import { type HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { tap } from 'rxjs';

import { ConsoleLogger } from './console-logger.service';

export const logHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(ConsoleLogger);

  return next(req).pipe(
    tap({
      error: error => {
        logger.error('http', `${req.method} ${req.url}`, error);
      },
      next: event => {
        if (event instanceof HttpResponse) {
          logger.info('http', `${event.status} ${req.method} ${req.url}`, event.body);
        }
      },
    }),
  );
};
